import { useState } from 'react';

const WHATSAPP_NUMBER = '5511964187853';
const WHATSAPP_MESSAGE = encodeURIComponent('Olá! Vim pelo site e gostaria de saber mais informações.');

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);

  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 group cursor-pointer"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      aria-label="Fale conosco pelo WhatsApp"
    >
      {/* Tooltip */}
      <span
        className={`whitespace-nowrap bg-white text-gray-800 text-sm font-medium px-4 py-2 rounded-full shadow-lg transition-all duration-300 ${
          hovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4 pointer-events-none'
        }`}
      >
        Fale conosco!
      </span>

      {/* Botão */}
      <div
        className="w-14 h-14 flex items-center justify-center rounded-full shadow-xl transition-transform duration-300 group-hover:scale-110"
        style={{ backgroundColor: '#25D366' }}
      >
        {/* Ping animado */}
        <span className="absolute w-14 h-14 rounded-full bg-green-400 opacity-40 animate-ping" />
        <i className="ri-whatsapp-line text-white text-3xl" />
      </div>
    </a>
  );
}
